<template>
  <div id="app">
    <img src="./assets/微信图片_20250118014622.jpg" alt="">

    <div class="form">
      <div class="item">
        <div class="name">您的姓名（已加密）*</div>
        <input type="text" v-model="formData.name" placeholder="请输入">
      </div>

      <div class="item">
        <div class="name">您的电话（已加密）*</div>
        <input type="text" v-model="formData.phoneNumber" placeholder="请输入">
      </div>

      <div class="item">
        <div class="name">您的地区（已加密）*</div>
        <input type="text" v-model="formData.area" placeholder="请输入">
      </div>

      <div class="btn" @click="submit">表单提交</div>
    </div>
  </div>
</template>
<script>
import { formDate } from './api/index'
export default {
  data() {
    return {
      formData: {
        name: '',
        phoneNumber: '',
        area: ''
      }
    }

  },
  created() {

  },
  methods: {
    submit() {
      if(this.formData?.name && this.formData?.phoneNumber && this.formData?.area) {
        formDate(this.formData).then(res => {
          console.log(res)
        })
      } else {
        alert('请输入正确信息！')
      }
    }
  }
}
</script>
<style lang="scss">
#app {
  position: relative;
  img {
    width: 100%;
  }
  .form {
    position: absolute;
    top: 13%;
    left: 0;
    width: 100%;
  }
  .item {
    display: flex;
    flex-direction: column;
    margin: 15px 25px;
    border-bottom: solid 1px #ccc;

    .name {
      color: #807f7f;
      font-size: 17px;
    }
    input {
      height: 30px;
      color: #807f7f;
      outline: none; /* 去掉聚焦时的边框 */
      background-color: transparent; /* 设置背景色为透明 */
      border: none; /* 去掉边框（可选，根据需求） */
      font-size: 16px;
    }
    input:focus {
      box-shadow: none; /* 去掉聚焦时的阴影效果 */
    }
    input::placeholder {
      color: #807f7f; /* placeholder 字体颜色 */
      font-size: 16px; /* placeholder 字体大小 */
      font-weight: none;
    }
  }
  .btn {
    margin: 0 25px;
    background-color: #61381a;
    font-size: 17px;
    padding: 10px 0;
    text-align: center;
    color: #fff;
    margin-top: 40px;
    cursor: pointer;
  }
}
body {
  margin: 0;
}
</style>
